"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CertificationEvent = void 0;
const base_model_1 = require("../base-model");
const certification_event_schema_1 = require("./certification-event.schema");
class CertificationEvent extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return certification_event_schema_1.certificationEventSchema;
    }
}
exports.CertificationEvent = CertificationEvent;
